<template>
  <div id="clientes">
    <div class="container-fluid">
      <div class="row" data-aos="fade-down">
        <div style="text-align:right; padding:40px; margin-top:100px;">
          <h4 style="font-size:20px;">
            <hr>{{state.title}}</h4>
        </div>
        <h1 data-aos="fade-down">{{state.subTitle}}</h1>
        <div class="clientes-container">
          <img data-aos="zoom-in" src="../../assets/logos/logo_alen_gris.png">
          <img data-aos="zoom-in" src="../../assets/logos/logo_cemenquin_gris.png">
          <img data-aos="zoom-in" src="../../assets/logos/logo_fevisa_gris.png">
          <img data-aos="zoom-in" src="../../assets/logos/logo_jumex_gris.png">

        </div>
        <div class="clientes-container">
          <img data-aos="zoom-in" src="../../assets/logos/logos_azteca_gris.png">
          <img data-aos="zoom-in" src="../../assets/logos/logo_maseca_gris.png">
          <img data-aos="zoom-in" src="../../assets/logos/logo_pazher_gris.png">
          <img data-aos="zoom-in" src="../../assets/logos/logo_psf_gris.png">

        </div>
        <div class="clientes-container">
          <img data-aos="zoom-in" src="../../assets/logos/logo_sunpower_gris.png">
          <img data-aos="zoom-in" src="../../assets/logos/logo_vitro_gris.png">
          <img data-aos="zoom-in" src="../../assets/logos/logo_zahori_gris.png">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  methods: {
  },
  components: {
  },
  computed: {
    state() {
      return this.$store.state.activeList.clientsHome
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';


.main-content {
  display: block;
  color: $gris;
  height: 100%;
}

hr {
  display: inline-block;
  vertical-align: middle;
  height: 2px;
  border: 0;
  width: 20%;
  border-top: 2px solid $rojo;
  margin: 1em 1em;
  padding: 0;
}

h1 {
  color: $azul;
  font-size: 40pt;
}

.text-container {
  text-align: left;
  margin-top: 5%;
}


.small-title {
  width: 100%;
  text-align: right;
  vertical-align: middle;
}

.clientes-container {
  margin: px;
}

.clientes-container img {
  width: 200px;
  margin: 25px;
}
</style>



// WEBPACK FOOTER //
// ClientesPage.vue?76fc8139